import { useRef } from "react";
import Image from "next/image";
import { getHtmlFromContent } from "@knowt/editor/helpers/getHtmlFromContent";
import styles from "./noteToPrint.module.css";
import { useNotePageContextSelector } from "@/components/NotePage/hooks/NotePageContext";
import HtmlText from "components/HtmlText";
import { ASSETS_URL } from "@/config/deployConstants";

const pdfLogo = `${ASSETS_URL}/images/PDFLogo.png`;

const NoteToPrint = () => {
    const note = useNotePageContextSelector(state => state.note);
    const noteToPrintRef = useNotePageContextSelector(state => state.noteToPrintRef);

    const titleRef = useRef<HTMLInputElement>(null);
    const exam = (note?.exam_v2 as string) || "";

    const isAp = exam.toLowerCase().includes("ap");

    return (
        <div
            ref={noteToPrintRef}
            className={styles.container}
            data-testid="auto-id-0ecef280-2693-4055-b5f4-e81cb0f0d932">
            <div
                className={styles.logo}
                data-testid="auto-id-b21851f9-5c6e-49b8-8d75-0b047b4268cd">
                {isAp ? (
                    <Image
                        src={`${ASSETS_URL}/images/APPrintLogo.png`}
                        alt={"knowt ap exam guide logo"}
                        width={80}
                        height={80}
                        style={{ objectFit: "contain" }}
                    />
                ) : (
                    <Image src={pdfLogo} alt={"knowt logo"} width={80} height={80} style={{ objectFit: "contain" }} />
                )}
            </div>
            <div
                className={styles.title}
                data-testid="auto-id-cdb54efb-2d12-4ca4-893b-b3bd86332961">
                <p ref={titleRef} data-testid="auto-id-1d1fb638-26b0-44f4-91e5-b006bcb80800">{note?.title || ""}</p>
            </div>
            <HtmlText
                text={getHtmlFromContent({ content: note?.content ?? "", type: "note" })}
                style={{ fontSize: "1.5rem" }}
            />
        </div>
    );
};

export default NoteToPrint;
